import React from "react";
import { Link } from "react-router-dom";

import { Fragment, useState } from "react";
import { Dialog, Popover, Tab, Transition, Menu } from "@headlessui/react";
import { MenuIcon, SearchCircleIcon, XIcon, PlusIcon, ChevronDownIcon } from "@heroicons/react/solid";

const navigation = {
  pages: [
    { name: "Dashboard", link: "/dashboard" },
    { name: "Refer & earn", link: "/dashboard/referrals" },
    { name: "Profile", link: "/profile" },
  ],
};

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

function Header({ handle, userEmail }) {
  const [open, setOpen] = useState(false);

  return (
    <div className="bg-white">
      {/* Mobile menu */}
      <Transition.Root show={open} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 flex justify-end z-40 lg:hidden"
          onClose={setOpen}
        >
          <Transition.Child
            as={Fragment}
            enter="transition-opacity ease-linear duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="transition-opacity ease-linear duration-300"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <Transition.Child
            as={Fragment}
            enter="transition ease-in-out duration-300 transform"
            enterFrom="translate-x-full"
            enterTo="translate-x-0"
            leave="transition ease-in-out duration-300 transform"
            leaveFrom="translate-x-0"
            leaveTo="translate-x-full"
          >
            <div className="relative max-w-xs w-full bg-white shadow-xl pb-12 flex flex-col overflow-y-auto">
              <div className="px-4 pt-5 pb-2 flex justify-between items-center">
                <button
                  type="button"
                  className="-m-2 p-2 rounded-md inline-flex items-center justify-center text-gray-600 hover:text-gray-800"
                  onClick={() => setOpen(false)}
                >
                  <span className="sr-only">Close menu</span>
                  <XIcon className="h-6 w-6" aria-hidden="true" />
                </button>
              </div>

              {/* User Email */}
              <div className="border-t border-gray-200 px-4 py-4">
                <p className="text-sm font-medium text-gray-700 truncate">{userEmail}</p>
              </div>

              {/* Navigation Links */}
              <div className="border-t border-gray-200 py-1 px-4">
                {navigation.pages.map((page) => (
                  <Link
                    key={page.name}
                    onClick={() => setOpen(false)}
                    to={page.link}
                    className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                  >
                    {page.name}
                  </Link>
                ))}
              </div>

              {/* Sign Out Button */}
              <div className="py-1 px-4">
                <button
                  onClick={handle}
                  className="block w-full text-left px-4 py-2 text-sm text-gray-700 border-t border-gray-200 hover:bg-gray-100"
                  type="button"
                >
                  Sign Out
                </button>
              </div>
            </div>
          </Transition.Child>
        </Dialog>
      </Transition.Root>

      <header className="relative bg-white">
        <nav aria-label="Top" className=" py-4 mx-auto px-4 sm:px-6 lg:px-8">
          <div className="border-b border-gray-200">
            <div className="h-16 flex items-center">
              {/* Logo */}
              <div className="lg:ml-0">
                  <Link to="/dashboard" className="flex items-center">
                  <SearchCircleIcon
                    className="sm:h-10 h-8 sm:w-10 w-8 text-primary "
                    aria-hidden="true"
                  />
                  <p className="text-primary font-bold font-[Poppins] ml-2 text-2xl">
                    Canadajobleads
                  </p>
                  </Link>

              </div>

              <div className="ml-auto flex items-center">
                <div className="hidden lg:flex lg:flex-1 lg:items-center lg:justify-end lg:space-x-4 ">
                  <Link to="/post-job">
                    <button
                      className="text-md font-medium text-white bg-primary px-4 py-1 rounded-lg border-2 border-primary hover:bg-white hover:text-primary ease-in duration-150 flex items-center"
                      type="button"
                    >
                      <PlusIcon className="h-4 w-4 mr-1" aria-hidden="true" />
                      New Job
                    </button>
                  </Link>

                  {/* User menu dropdown */}
                  <Menu as="div" className="relative z-50">
                    <Menu.Button className="text-md font-medium text-gray-700 hover:text-gray-900 px-3 py-1 rounded-lg flex items-center">
                      <span className="max-w-xs truncate">{userEmail}</span>
                      <ChevronDownIcon className="h-5 w-5 ml-1" aria-hidden="true" />
                    </Menu.Button>
                    <Transition
                      as={Fragment}
                      enter="transition ease-out duration-100"
                      enterFrom="transform opacity-0 scale-95"
                      enterTo="transform opacity-100 scale-100"
                      leave="transition ease-in duration-75"
                      leaveFrom="transform opacity-100 scale-100"
                      leaveTo="transform opacity-0 scale-95"
                    >
                      <Menu.Items className="absolute right-0 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                        <div className="py-1">
                          {navigation.pages.map((page) => (
                            <Menu.Item key={page.name}>
                              {({ active }) => (
                                <Link
                                  to={page.link}
                                  className={classNames(
                                    active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                                    'block px-4 py-2.5 text-sm'
                                  )}
                                >
                                  {page.name}
                                </Link>
                              )}
                            </Menu.Item>
                          ))}
                          <Menu.Item>
                            {({ active }) => (
                              <button
                                onClick={handle}
                                className={classNames(
                                  active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                                  'block w-full text-left px-4 py-2.5 text-sm border-t border-gray-200'
                                )}
                              >
                                Sign Out
                              </button>
                            )}
                          </Menu.Item>
                        </div>
                      </Menu.Items>
                    </Transition>
                  </Menu>
                </div>
                <button
                  type="button"
                  className="bg-white p-2 rounded-md text-gray-600 hover:text-gray-800 lg:hidden"
                  onClick={() => setOpen(true)}
                >
                  <span className="sr-only">Open menu</span>
                  <MenuIcon className="h-6 w-6" aria-hidden="true" />
                </button>
              </div>
            </div>
          </div>
        </nav>
      </header>
    </div>
  );
}

export default Header;
